import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-right",
  "use": "icon-ib-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-right\">\n    <path d=\"M896 512a32 32 0 0 0-32-32h-704a32 32 0 0 0 0 64h704A32 32 0 0 0 896 512z\" p-id=\"6871\" />\n    <path d=\"M553.344 201.344a32 32 0 0 0 0 45.312L818.752 512l-265.408 265.344a32 32 0 0 0 45.312 45.312l288-288a32 32 0 0 0 0-45.312l-288-288a32 32 0 0 0-45.312 0z\" p-id=\"6872\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol